import styled from 'styled-components';

export const StyledFarmEdit = styled('div')`
  .ant-input {
    border-radius: 3px;
  }

  .infrastructures-buttons {
    display: flex;
    gap: 10px;
  }
`;

export const StyledBusinessTab = styled('div')`
  display: flex;
  flex-direction: column;
  font-family: ${(props) => props.theme.fontText};

  .ant-table-wrapper {
    margin: 20px 0 0 0;
    .ant-table-thead {
      height: 75px;
      .ant-table-cell {
        padding: 0 0 0 25px;
        font-weight: 400;
        color: ${(props) => props.theme.black};
      }
    }

    .ant-table-tbody {
      .ant-table-cell {
        color: ${(props) => props.theme.colorText};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 331px;
        padding: 16px 24px;
        height: 72px;

        .ant-btn {
          padding: 5px 10px 5px 10px;
          border-radius: 3px;
          border: 1px solid ${(props) => props.theme.colorText};
          color: ${(props) => props.theme.colorButtonText};
          height: 26px;
          .ant-btn-icon {
            div {
              display: flex;
            }
          }
        }
      }

      .ant-table-cell::before {
        display: none;
        color: red;
      }

      .ant-table-cell.centered-column {
        text-align: center;
      }
    }
    .ant-table-cell::before {
      display: none;
      color: red;
    }

    .ant-table-cell.centered-column {
      text-align: center;
    }
  }

  .open-hours {
    text-wrap: nowrap;
  }

  .new-btn {
    width: fit-content !important;
    font-family: ${(props) => props.theme.fontText};
    border-radius: 3px;
  }

  .input-filelist {
    display: flex;
    gap: 100px;
  }

  .input-filelist.column {
    flex-direction: column;
    gap: 0;

    .ant-form-item-control-input {
      width: 250px;
    }
  }

  .double-input-date {
    display: flex;
    gap: 20px;
  }

  .yt {
    padding-bottom: 50px;
    max-width: 430px;
    label {
      bottom: -10px;
    }
  }

  .gallery,
  .video {
    padding-top: 100px;
  }

  h3 {
    margin-bottom: 5px;
  }

  .upload-content {
    display: flex;
  }

  .content {
    min-height: 100%;

    .section {
      max-width: 844px;
      min-height: 200px;

      .ant-input.ant-input-disabled {
        color: ${(props) => props.theme.colorPrimary} !important;
      }

      .double-column-checkbox {
        .ant-checkbox-group {
          display: grid;
          grid-template-columns: 50% 50%;
          gap: 0.5em;
          column-gap: 25%;
          .ant-checkbox-wrapper {
            .ant-checkbox {
              padding-right: 5px;

              .ant-checkbox-inner:after {
                transform: rotate(45deg) scale(1) translate(-70%, -50%);
              }
            }
            span {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }

      .double-column-checkbox-two-sixteen {
        .ant-checkbox-group {
          display: grid;
          grid-template-columns: 50% 50%;
          gap: 0.5em;
          column-gap: 5%;
          .ant-checkbox-wrapper {
            .ant-checkbox {
              padding-right: 5px;
            }
            span {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }

    textarea {
      height: 80px;
      border-radius: 5px;
      resize: none;
    }

    .text-area {
      label {
        position: relative;
        top: 8px;
      }

      .ant-input-data-count {
        position: relative;
        right: 5px;
      }

      .ant-input {
        height: 150px;
      }
      .ant-input-suffix {
        display: flex;
        flex-direction: column-reverse;
      }
    }

    .bottom-border-wrapper {
      position: relative;
      width: 100vw;

      .bottom-border {
        border-bottom: 1px solid ${(props) => props.theme.borderInput};
        padding-top: 20px;
        width: 100%;
      }
    }

    .label-fix {
      .ant-col {
        padding-bottom: 0;
      }
    }

    .ant-form-item {
      margin-bottom: 10px;
    }

    .ant-form-item-control-input-content {
      input {
        border-color: ${(props) => props.theme.borderInput};
      }
    }
  }

  .double-checkbox {
    display: flex;
    gap: 133px;
    .ant-form-item {
      margin-bottom: 10px;
      .ant-checkbox-inner:after {
        transform: rotate(45deg) scale(1) translate(-65%, -58%);
      }
    }
  }

  .double-input {
    display: flex;
    justify-content: space-between;

    .ant-form-item-control-input {
      min-width: 407px;
    }
  }
`;

export const StyledBusinessInformation = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const StyledBusinessDraggerGallery = styled('div')`
  display: flex;
  gap: 100px;

  .action {
    cursor: pointer;
    text-decoration: underline;
    color: ${(props) => props.theme.colorPrimary};
  }

  .upload {
    display: flex;
    flex-direction: column;

    .ant-upload-wrapper {
      .ant-upload-btn {
        padding: 0;

        .ant-upload-drag-icon {
          margin-bottom: 5px;
        }
      }
      .ant-upload {
        min-height: 98px;
        background-color: ${(props) => props.theme.white};

        .ant-upload-text {
          max-height: 98px;
          a {
            color: ${(props) => props.theme.blue};
            font-weight: 600;
          }
        }
      }
    }
  }
`;
